export const promocodesAPI = {
  async getCategories(store) {
    const response = await fetch(`${store.getters.getBackendUrl}/promocodes/categories`, {
      headers: {
        'Accept-Language': store.getters.getLanguage,
        'Auth-Token': store.getters.getToken,
        'Leadhit-Site-Id': store.getters.getSiteId
      }
    })
    const data = await response.json()
    return data
  }
} 


// WEBPACK FOOTER //
// ./src/services/promocodes.js